module.exports = __webpack_public_path__ + "static/media/clock.97c98201.svg";